import type { GeocoderAddressComponent } from "./jurisdictionFromPlace.ts"

export async function reverseGeocodeLatLng(
  lat: number,
  lng: number
): Promise<{ formattedAddress: string; addressComponents: GeocoderAddressComponent[] }> {
  const Geocoder = window.google?.maps?.Geocoder as
    | (new () => {
        geocode(
          request: { location: { lat: number; lng: number } },
          callback: (
            results: Array<{
              formatted_address?: string
              address_components?: Array<{
                long_name: string
                short_name: string
                types: string[]
              }>
            }> | null,
            status: string
          ) => void
        ): void
      })
    | undefined

  if (!Geocoder) {
    return Promise.reject(new Error("Geocoder no disponible"))
  }

  return new Promise((resolve, reject) => {
    const geocoder = new Geocoder()
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status !== "OK" || !results?.[0]) {
        reject(new Error("Geocoding fallido"))
        return
      }
      const r = results[0]
      const formattedAddress = r.formatted_address ?? ""
      const addressComponents = (r.address_components ?? []).map((ac) => ({
        long_name: ac.long_name,
        short_name: ac.short_name,
        types: ac.types ?? [],
      }))
      resolve({ formattedAddress, addressComponents })
    })
  })
}
